import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { BookingDAO } from '../../../../core/services/dao/bookingDAO';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class BookingsResolve implements Resolve<any> {
  constructor(
    private bookingDAO: BookingDAO,
    private roleDAO: RoleDAO,
    private authService: AuthService,
    private captainDAO: CaptainDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const bookingResolve = this.bookingDAO.load();
    const sessionResolve = this.authService.checkSession();
    return combineLatest([sessionResolve, bookingResolve]).pipe(
      map(([sessionResolve, bookingResolve]) => ({
        sessionResolve,
        bookingResolve,
      })),
      take(1),
    );
  }
}
